import { EnrichErrorType } from './error-type.enum';

export class EnrichError {
  type: EnrichErrorType;
  message?: string;

  constructor(type: EnrichErrorType, message?: string) {
    this.type = type;
    this.message = message;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/error.ts